import { Button, Dialog, DialogContent, Typography } from '@mui/material'

interface SuccessModalProps {
  open: boolean
  onClose: () => void
}

export default function SuccessModal({ open, onClose }: SuccessModalProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '16px',
          maxWidth: '400px',
          width: '100%',
          margin: '16px',
          backgroundColor: (theme) => theme.palette.background.paper,
          color: 'white'
        }
      }}
    >
      <DialogContent sx={{ textAlign: 'center', p: 4 }}>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 'bold',
            marginBottom: '16px',
            color: 'white'
          }}
        >
          You&apos;re all set.
        </Typography>
        <Typography
          variant="body1"
          sx={{
            marginBottom: '16px',
            color: 'white',
            opacity: 0.9
          }}
        >
          Your purchase was successful.
        </Typography>
        <Button
          variant="contained"
          onClick={onClose}
          sx={{
            backgroundColor: 'primary.main',
            color: 'white',
            borderRadius: '8px',
            padding: '12px 32px',
            fontSize: '16px',
            fontWeight: 'bold',
            textTransform: 'none',
            '&:hover': {
              backgroundColor: '#0056b3'
            }
          }}
        >
          OK
        </Button>
      </DialogContent>
    </Dialog>
  )
}
